<template>
  <div>
    <editor
      v-model="computedContent"
      :init="{
        height: 200,
        menubar: false,
        statusbar: false,
        plugins: 'paste, lists',
        paste_as_text: true,
        placeholder: placeholder || '',
        toolbar:
          'bold italic | \ alignleft aligncenter alignright alignjustify | \ bullist numlist outdent indent',
      }"
    ></editor>
    <input type="hidden" :name="inputname" :value="content" />
  </div>
</template>

<script>
import 'tinymce'
import Editor from "@tinymce/tinymce-vue"

/* Required TinyMCE components */
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js';
import 'tinymce/models/dom/model.min.js';

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.js';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

/* content UI CSS is required */
import 'tinymce/skins/ui/oxide/content.js';

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
import 'tinymce/skins/content/default/content.js';

export default {
  props: {
    inputname: String,
    placeholder: String,
    initContent: String,
    inputcontent: String,
  },
  data() {
    return {
      content: '',
    };
  },
  computed: {
    computedContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.content = value;
        this.$emit('change', this.content);
      },
    },
  },
  mounted() {
    this.content = this.initContent || this.inputcontent;
  },
  components: {
    editor: Editor,
  },
};
</script>
